<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <div style="margin-bottom:1px">
      <el-button size="mini" type="primary text2" @click="searchs" style="margin-top: 10px;">刷新</el-button>
    </div>
    <div style="margin-top: 10px;">{{house}}</div>
    <el-table ref="multipleTable" height="800" :data="data" border style="width: 99%">
      <el-table-column prop="chargeItem_name" label="收费项目" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cdj_ChargeItemID" label="ERP收费项目ID" width="200"></el-table-column>
      <el-table-column prop="chargePay" label="ERP同步新视窗收费金额"width="200"></el-table-column>
      <el-table-column prop="chargePay1" label="ERP生成收费金额" width="200"></el-table-column>
      <el-table-column prop="ChargeItemID" label="新视窗收费项目ID" width="200"></el-table-column>
      <el-table-column prop="ChargeSum" label="新视窗收费金额" width="200"></el-table-column>
      <el-table-column prop="cha" label="差异" width="200"></el-table-column>
    </el-table>
  </div>
</div>
</template>

<script>
import imgurl from "../../../../store/state.js";
import print from 'print-js';
export default {
  name: "OrderDeposit",
  data () {
    return {
      selectList:[],
      project_id:'',
      loading:false,
      charge:[],
      house:[],
      data: '',
      pid: '',
      text:'',
      state:'1',
      url:'',
      fileList:[],
      form:{
        pindex_id:'',
        house_id:'',
        name:'',
        house:'',
        business_type:1,
        deposit_type:'',
        charge_money:'',
        charge_date:'',
        bill_type:'',
        bill_number:'',
        beizhus:'',
        payee:'',
      },
      statesForm:{
        id:'',
        retreat_money:'',
        retreat_date:'',
        remarks:'',
      },
      deposit_type:[],
      date:'',
      deposit_date:'',
      deposit:[],
      capitalize:'',
      login:'',
      house:'',
      datevalue:'',
    }
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue')
  },
  created() {
  },
  mounted(){
    this.change(1);
  },
  methods: {
    //树搜索
    nodeClick(data){
      let project = data.tree[0];
      this.house = project.name;
      this.project_id = project.pindex_id;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.text = tree_str;
      this.form.house = tree_str;
      this.form.name = '';
      this.change(1);
      let tree = data.tree;
      // console.log(tree)
      this.form.pindex_id = tree[0].id;
      let _this = this;
      this.form.bill_type = "";
      this.form.bill_number = "";
      tree.forEach(function(it){
        if(it.type == 'room'){
          _this.form.name = it.hname;
          _this.form.house_id = it.id;
        }
      })
    },
    //分页
    change(page){
      ERP.showLoading()
      this.$myhttp.get('xsc/charge/index?toker=ahdsdjajdioajwdjawkjdklasdadklas&pid='+this.project_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          ERP.hideLoading()
          let data = backdata.data;
          this.data = data.data;
      });
    },
    //搜索
    searchs(){
      this.change(1);
    },
  },
  watch:{

  },
}
</script>

<style>
  .el-input.is-disabled .el-input__inner {
      background-color: #F5F7FA;
      border-color: #E4E7ED;
      color: #3e3f42 !important;
      cursor: not-allowed;
  }
</style>

<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
}
.loading{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/Comparison/Charge.vue